import styles from "./index.module.css";
import Replay from "../../assets/images/Replay.png";
import img4 from "../../assets/images/LearnMore4.png";
import img5 from "../../assets/images/LearnMore5.png";
import FolderImg from "../../assets/images/FolderLogo.png";
import MyDocumentTile from "../MyDocumentTile";
import pdfFile from "../../assets/pdf/Introduction_to_Inception_Financial_2026.pdf";
import { tracker } from "../../services/mixpanel";
import ResouceLibary4 from "../../assets/images/ResourceLibraryClean.png";

interface Props {
  openOverlay: (url: string) => void;
  openAnimatedOverview: (url: string) => void;
  openOverlay1: (componentData: any) => void;
}

const Tile1 = ({ openOverlay, openAnimatedOverview, openOverlay1 }: Props) => {
  const handleDocumentModal = (
    id: string,
    heading: string,
    showSidebar?: boolean //undefined-> show sidebar  | true or false -> hide sidebar
  ) => {
    tracker.dashboard.documentModal.onOpen(heading);
    openOverlay1(
      <MyDocumentTile
        folder={{ id: id }}
        type="FromLearnMore"
        showSidebar={showSidebar}
        heading={heading}
      />
    );
  };

  const handlePdfModal = (name: string, link: string) => {
    tracker.dashboard.overview.pdfModal.onOpen(name);
    openOverlay(link);
  };

  const handleVideoModal = (name: string, link: string) => {
    tracker.dashboard.overview.videoModal.onOpen(name);
    openAnimatedOverview(link);
  };

  return (
    <div className={`${styles.tile} ${styles.customTile} `}>
      <h2 className={styles.heading}>Overview</h2>
      <div className="grid gap-y-3 m-2 grid-cols-3">
        <div
          className={styles.tile1Box}
          onClick={() =>
            window.open(
              "https://learn.zohopublic.com/external/manual/inception-financial-knowledge-base?p=bf80f12473e7535675946df5b62034cc7fb015d0047609dbd60961acab25116f",
              "_blank"
            )
          }
        >
          <img className={styles.tile1Img} src={ResouceLibary4} alt="" />
          <h3 className={styles.tileheading}>KNOWLEDGE CENTER</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handleVideoModal(
              "ANIMATED OVERVIEW",
              "https://player.vimeo.com/video/949543563?h=1cc197bf6a&badge=0&autopause=0&amp;&player_id=0&app_id=58479"
            )
          }
        >
          <img className={styles.replay} src={Replay} alt="" />
          <h3 className={styles.tileheading}>ANIMATED OVERVIEW</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handleVideoModal(
              "CLIENT PRESENTATION VIDEO",
              "https://player.vimeo.com/video/1001799796?h=92ddd84060&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            )
          }
        >
          <img className={styles.replay} src={Replay} alt="" />
          <h3 className={styles.tileheading}>CLIENT PRESENTATION VIDEO</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handleVideoModal(
              "PRO FORMA REVIEW",
              "https://player.vimeo.com/video/955081780?h=7c048b1e7d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            )
          }
        >
          <img className={styles.replay} src={Replay} alt="" />
          <h3 className={styles.tileheading}>PRO FORMA REVIEW</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handlePdfModal(
              "ONE PAGE OVERVIEW",
              "https://drive.google.com/file/d/18k_M8s0dw-4G178-oOSZ5p-3JcmRyZK8/preview"
            )
          }
        >
          <img className={styles.learnMoreImg} src={img4} alt="" />
          <h3 className={styles.tileheading}>ONE PAGE OVERVIEW</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() => handlePdfModal("CLIENT PRESENTATION PPT", pdfFile)}
        >
          <img className={styles.learnMoreImg} src={img5} alt="" />
          <h3 className={styles.tileheading}>CLIENT PRESENTATION PPT</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handleDocumentModal(
              "1rKmZ2sOsOCuJcRGvddP54yZGJsAXLetc",
              "Sample Asset Documents"
            )
          }
        >
          <img className={styles.learnMoreImg} src={FolderImg} alt="" />
          <h3 className={styles.tileheading}>SAMPLE ASSET DOCUMENTS</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handleDocumentModal(
              "1f6aIYHRSphrs6BteWYXBmzR5vPLfLATF",
              "Sample Agreements",
              false
            )
          }
        >
          <img className={styles.learnMoreImg} src={FolderImg} alt="" />
          <h3 className={styles.tileheading}>SAMPLE AGREEMENTS</h3>
        </div>
        <div
          className={styles.tile1Box}
          onClick={() =>
            handleDocumentModal(
              "1TJmrVANBJgeKeNDTnKx3PD_Qt74ZDrqU",
              "Sample Tax Documents",
              false
            )
          }
        >
          <img className={styles.learnMoreImg} src={FolderImg} alt="" />
          <h3 className={styles.tileheading}>SAMPLE TAX DOCUMENTS</h3>
        </div>

        {/* <div
              className={styles.tile1Box}
              onClick={() =>
                openOverlay(
                  "https://learn.zohopublic.com/external/manual/inception-financial-sample-tax-forms?p=bf80f12473e7535675946df5b62034ccbdad2a880b0a94901c686bd8bc9127c4"
                )
              }
            >
              <img className={styles.tile1Img} src={Replay} alt="" />
              <h3 className={styles.tileheading}>SAMPLE TAX FORMS</h3>
            </div> */}
      </div>
    </div>
  );
};

export default Tile1;
